// extracted by mini-css-extract-plugin
export var bullet = "_mp-q";
export var bulletText = "_mp-p";
export var bullets = "_mp-k";
export var callout = "_mp-g";
export var calloutBody = "_mp-i";
export var calloutLabel = "_mp-h";
export var checkIcon = "_mp-m";
export var checkList = "_mp-j";
export var checkSvg = "_mp-n";
export var checkText = "_mp-o";
export var fieldCard = "_mp-1";
export var fieldDescription = "_mp-5";
export var fieldHeader = "_mp-3";
export var fieldTitle = "_mp-4";
export var finalNote = "_mp-s";
export var flow = "_mp-x";
export var flowArrow = "_mp-v";
export var flowStep = "_mp-u";
export var helperText = "_mp-r";
export var inlineTitle = "_mp-t";
export var listItem = "_mp-l";
export var noteBody = "_mp-8";
export var noteBodyText = "_mp-9";
export var noteCard = "_mp-2";
export var noteIcon = "_mp-6";
export var noteTitle = "_mp-7";
export var productChoices = "_mp-w";
export var radioDot = "_mp-d";
export var radioDotSelected = "_mp-e";
export var radioDotSvg = "_mp-f";
export var selectableCard = "_mp-b";
export var selectableCardSelected = "_mp-c";
export var strongText = "_mp-a";
export var subHeading = "_mp-0";